import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position when the route changes.
 *
 * The app's scroll container is the <main id="main-scroll"> element inside
 * MainLayout (which persists across navigations), not the window — so both
 * are reset to be safe.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.getElementById('main-scroll');
    if (main) {
      main.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
